import { render, staticRenderFns } from "./formDetailAffairs.vue?vue&type=template&id=423050c5&"
import script from "./formDetailAffairs.vue?vue&type=script&lang=js&"
export * from "./formDetailAffairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports